module.exports = __webpack_public_path__ + "img/qiwi-white.15a85adb.svg";